/**
 * The colour family a tagged connector wears, looked up from the catalogue
 * views the app already holds: personal connections for `personal` tags,
 * the organisation's integrations for `workspace` tags. Only the view the
 * tag needs is read, so a personal chip never fetches the integrations.
 *
 * @module state/connectorAccent
 */
import { useConnectionAccentFamily } from "./connections";
import { useIntegrationAccentFamily } from "./governance";
import { useActiveOrgId } from "./orgs";

export function useConnectorAccentFamily(
  scope: "personal" | "workspace",
  connectorId: string,
): string | null {
  const orgId = useActiveOrgId();
  const personal = useConnectionAccentFamily(connectorId, scope === "personal");
  const workspace = useIntegrationAccentFamily(scope === "workspace" ? orgId : null, connectorId);
  return scope === "personal" ? personal : workspace;
}
